'use client'

import { createContext, ReactNode, useContext, useLayoutEffect } from 'react'

import { TPage } from '@/shared/types/deprecated-types'

type BreadcrumbsSetter = (pages?: TPage[]) => void

const LayoutBreadcrumbsSetterContext = createContext<BreadcrumbsSetter | null>(null)

type ProviderProps = {
	children: ReactNode
	setBreadcrumbs: BreadcrumbsSetter
}

export const LayoutBreadcrumbsSetterProvider = ({ children, setBreadcrumbs }: ProviderProps) => {
	return (
		<LayoutBreadcrumbsSetterContext.Provider value={setBreadcrumbs}>{children}</LayoutBreadcrumbsSetterContext.Provider>
	)
}

type OverrideProps = {
	pages?: TPage[]
}

export const LayoutBreadcrumbsOverride = ({ pages }: OverrideProps): any => {
	const setBreadcrumbs = useContext(LayoutBreadcrumbsSetterContext)

	useLayoutEffect(() => {
		if (!setBreadcrumbs) return

		setBreadcrumbs(pages)

		// Reset on unmount so stale breadcrumbs don't persist when navigating to pages
		// that rely on the static routePages fallback (no LayoutBreadcrumbsOverride).
		return () => setBreadcrumbs(undefined)
	}, [setBreadcrumbs, pages])

	return null
}
